module.exports = __webpack_public_path__ + "img/04.ac465a84.png";